import React from "react";
import DateHelper from "../../DateHelper/DateHelper";

class DateTimeDataType extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.data) {
      return (
        <div className={this.renderAlignment()}>
          {DateHelper.printDateToScreen(
            this.props.data,
            this.props.date_format + " " + this.props.time_format,
            true
          )}
        </div>
      );
    } else {
      return (
        <div className={this.renderAlignment()}>
          <em>{I18n.t("na")}</em>
        </div>
      );
    }
  }

  renderAlignment() {
    if (this.props.header && this.props.header.text_align === "left") {
      return "text-left";
    } else if (this.props.header && this.props.header.text_align === "center") {
      return "text-center";
    } else if (this.props.header && this.props.header.text_align === "right") {
      return "text-right";
    } else {
      ("");
    }
  }
}

export default DateTimeDataType;
